import React from "react";
import StatisticsDiv from "../../../components/Statistics/StatisticsDiv";

interface Props {
  value: server.dto.ClientOnboardingDashboard
  onClick: (filter: server.dto.ClientOnboardingDashboardFilterOptions) => void
}

const OnboardingStatisticsDiv = ({ value, onClick }: Props) => {
  return <div className="statistics-wrapper">

    <StatisticsDiv
      count={value.waitingForUserAccessingForm}
      label={"Initialized"}
      onClick={() => { onClick("onlyInitialized"); }}
    />

    <StatisticsDiv
      count={value.userIsFillingForm}
      label={"Filling in form"}
      onClick={() => { onClick("waitingForFillForm"); }}
    />

    <StatisticsDiv
      count={value.readyToCreateClientAccount}
      label={"Ready to create account"}
      onClick={() => { onClick("readyToCreateClientAccount"); }}
    />

    <StatisticsDiv
      count={value.clientAccountWasCreated}
      label={"Client account created"}
      onClick={() => { onClick("clientAccountWasCreated"); }}
    />
  </div>;
};

export default OnboardingStatisticsDiv;